import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';
import { BasicButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import InlineEdit from '@adsk/alloy-react-inline-edit';
import { useLocale } from '@adsk/alloy-react-helpers';
import { useFormikContext } from 'formik';
import { getInlineEditStyle } from '../../styles';
import {
  companyImageStyles,
  dividerStyles,
  flexContainer,
  mainContainerStyles,
  rightContainerStyles,
  centerContainerStyles,
  ownerTag,
} from './styles';

const Header = ({
  imageUrl,
  isAccountVariant,
  name,
  onClose,
  owner,
  updateCompany,
  websiteUrl,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { errors, setFieldError, setFieldValue, values } = useFormikContext();

  return (
    <div css={mainContainerStyles}>
      <div css={flexContainer}>
        <div>
          <img css={companyImageStyles} src={imageUrl} alt={name} />
        </div>
        <div css={centerContainerStyles}>
          <InlineEdit
            data-testid="CompanyProfilePanel_inlineEdit_name"
            disabled={!isAccountVariant}
            error={!!errors.name}
            inputProps={{
              onChange: (event) => {
                if (event.target.value === '') {
                  setFieldError('name', 'required');
                } else if (errors.name) {
                  setFieldError('name', undefined);
                }
              },
            }}
            onChange={(value) => updateCompany('name', value.substring(0, 255))}
            onEditEnter={() => setFieldValue('activeEditField', 'name')}
            onEditExit={() => setFieldValue('activeEditField', null)}
            placeholder={T.translate('NAME_PLACEHOLDER')}
            renderValue={(value) => (
              <div css={theme.typography.bodyMediumBold}>{value}</div>
            )}
            showPencilOnHoverOnly
            style={getInlineEditStyle(
              isAccountVariant,
              name == null || name === '',
              values.activeEditField === 'name'
            )}
            value={values.name}
          />
          <InlineEdit
            data-testid="CompanyProfilePanel_inlineEdit_websiteUrl"
            disabled={!isAccountVariant}
            onChange={(value) => updateCompany('websiteUrl', value)}
            onEditEnter={() => setFieldValue('activeEditField', 'websiteUrl')}
            onEditExit={() => setFieldValue('activeEditField', null)}
            placeholder={T.translate('WEBSITE_PLACEHOLDER')}
            showPencilOnHoverOnly
            style={getInlineEditStyle(
              isAccountVariant,
              websiteUrl == null || websiteUrl === '',
              values.activeEditField === 'websiteUrl'
            )}
            value={values.websiteUrl}
          />
          {owner && isAccountVariant && (
            <div css={ownerTag}>{T.translate('ACCOUNT_OWNER_COMPANY_TAG')}</div>
          )}
          {owner && !isAccountVariant && (
            <div css={ownerTag}>{T.translate('PROJECT_OWNER_COMPANY_TAG')}</div>
          )}
        </div>
        <div css={rightContainerStyles}>
          <BasicButton
            onClick={onClose}
            data-testid="CompanyProfilePanel_CloseButton"
          >
            <XIcon />
          </BasicButton>
        </div>
      </div>
      <Divider style={dividerStyles} />
    </div>
  );
};

Header.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  isAccountVariant: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  owner: PropTypes.bool.isRequired,
  updateCompany: PropTypes.func.isRequired,
  websiteUrl: PropTypes.string,
};

Header.defaultProps = {
  imageUrl: undefined,
  onClose: undefined,
  websiteUrl: undefined,
};

export default Header;
